export default "__VITE_ASSET__Ue2dag2k__"